import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  CONTACT_EMAIL,
  DEPARTMENT,
  EMPLOYEE_REPRESENTATIVE_NAME,
  ROLE,
} from 'constants/formFields';
import { DEFAULT_OPTION, OPTION_ROLE_EMPLOYEES } from 'constants/general';
import getValueOption from 'utils/getOptionValue';
import { employeesCreateSchema } from 'utils/validators';

import type { TEmployeesCreateSchema } from 'utils/validators';
import type ICreateEmployeesForm from '../interfaces/ICreateEmployeesForm';

const useCreateEmployeesForm = ({ isPageLoading, selectedItem, employeesEnumList }: ICreateEmployeesForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TEmployeesCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(employeesCreateSchema),
    defaultValues: {
      [DEPARTMENT]: DEFAULT_OPTION,
      [ROLE]: DEFAULT_OPTION,
      [EMPLOYEE_REPRESENTATIVE_NAME]: '',
      [CONTACT_EMAIL]: '',
    },
  });

  useEffect(() => {
    if (selectedItem && employeesEnumList) {
      setValue(DEPARTMENT, getValueOption(employeesEnumList, selectedItem.eployeeDepartment));
      setValue(ROLE, getValueOption(OPTION_ROLE_EMPLOYEES, selectedItem.eployeeRole));
      setValue(EMPLOYEE_REPRESENTATIVE_NAME, selectedItem.contactName);
      setValue(CONTACT_EMAIL, selectedItem.contactEmail);
    }
  }, [selectedItem, setValue, employeesEnumList]);

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useCreateEmployeesForm;
